import { TutorialDefinition } from '../../../types/tutorial';

export const mediaPlayerTutorial: TutorialDefinition = {
  id: 'media-player',
  initialAnimation: 'top',
  steps: [
    {
      id: 'player-intro',
      title: 'Media player controls',
      content:
        "<p>Your file is now uploaded! Use the media player to listen to your audio or watch your video while we're working on the transcript.</p>",
      placement: 'center',
    },
    {
      id: 'playback-controls',
      targetSelector: '[data-tutorial="playback-controls"]',
      title: 'Playback controls',
      content:
        '<p>Use these buttons to control playback: skip backward 10 seconds, play/pause, and skip forward 10 seconds. Perfect for reviewing specific sections.</p>',
      placement: 'bottom',
      offsetY: 10,
    },
    {
      id: 'timeline',
      targetSelector: '[data-tutorial="timeline"]',
      title: 'Seek timeline',
      content:
        '<p>Click anywhere on the timeline to jump to that point in your media. Great for quick navigation!</p>',
      placement: 'bottom',
      offsetY: 10,
    },
    {
      id: 'playback-speed',
      targetSelector: '[data-tutorial="playback-speed"]',
      title: 'Playback speed',
      content:
        '<p>Adjust the playback speed to transcribe faster or review more carefully. Choose from 0.5x to 2x speed.</p>',
      placement: 'bottom',
      offsetY: 10,
    },
    {
      id: 'picture-in-picture',
      targetSelector: '[data-tutorial="picture-in-picture"]',
      title: 'Picture-in-picture mode',
      content:
        '<p>For video files, you can enable Picture-in-Picture mode to extend the transcript area.</p>',
      placement: 'bottom',
      offsetY: 10,
    },
  ],
};
